import { FC, lazy } from 'react'
import { Colors } from 'src/components/theme'
import { WidgetCard } from 'src/v2/components/widget-card'

const AcquisitionsOverviewGraph = lazy(
  () => import('src/v2/views/owner-reveal/insights/owner-summary/acquisitions-overview-graph/graph')
)

export const AcquisitionsOverviewGraphCard: FC = () => {
  return (
    <WidgetCard
      id="acquisitions-overview"
      title="Acquisitions Overview"
      headerBgColor={Colors.primaryRed700}
      headerTextColor={Colors.textWhite}
      sections={[
        {
          content: <AcquisitionsOverviewGraph />,
        },
      ]}
    />
  )
}
